import { createReducer } from '@reduxjs/toolkit'

import { keywordsTableColumnsConfig } from 'configuration/tables/keywordTable'
import {
    DATES,
    KEYWORD_TEXT,
    KEYWORD_MATCH_TYPES,
    KEYWORD_STATES,
    METRIC_FILTERS,
    AD_GROUPS,
    AD_GROUP_STATES,
} from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    KEYWORD_STATE_LABELS,
    STATE_FIELD_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [KEYWORD_TEXT]: null,
        [AD_GROUPS]: [],
        [AD_GROUP_STATES]: [
            {
                value: ENABLED,
                label: STATE_FIELD_OPTIONS[ENABLED],
            },
        ],
        [KEYWORD_MATCH_TYPES]: [],
        [KEYWORD_STATES]: [
            {
                value: ENABLED,
                label: KEYWORD_STATE_LABELS[ENABLED],
            },
        ],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [KEYWORD_TEXT, DATES, AD_GROUPS, AD_GROUP_STATES],
        order: [KEYWORD_MATCH_TYPES, KEYWORD_STATES, METRIC_FILTERS],
        displayState: {
            [KEYWORD_MATCH_TYPES]: true,
            [KEYWORD_STATES]: true,
            [METRIC_FILTERS]: true,
        },
        userAdded: [AD_GROUP_STATES, KEYWORD_STATES],
    },
    table: getDefaultTable(serializeColumns(keywordsTableColumnsConfig)),
}

export default createReducer(initialState, () => {})
